<div class="flex flex-col grow shrink-0 rounded-[8px] border border-solid border-[#D9E3E5]">
  @if (authService.accountDto(); as account) {
    <div
      class="min-h-[46px] hover:bg-[#F2F4F5] flex items-center py-[5px] pl-[6px] pr-[8px] grow shrink-0 cursor-pointer bg-[#F2F4F5] pointer-events-none border-b border-solid border-[#D9E3E5]">
      <div class="flex items-center w-full max-w-[calc(100%-24px)]">
        @if (account.accountType === 'PERSONAL') {
        <div class="min-w-[34px] w-[34px] h-[34px] rounded-[50%] flex flex-col items-center justify-center">
          <img src="assets/img/profile-placeholder.png" alt="user-photo" class="w-[34px] h-[34px] object-cover">
        </div>
        } @else {
        <div class="min-w-[34px] w-[34px] h-[34px] rounded-[50%] flex flex-col items-center justify-center">
          <img src="assets/img/profile-placeholder-2.svg" alt="user-photo" class="w-[20px] h-[17px] object-cover">
        </div>
        }
        <div class="flex flex-col ml-2 overflow-hidden">
          <span class="text-[12px] text-[#323142] whitespace-nowrap text-ellipsis overflow-hidden">
            @switch (account.accountType) {
              @case ('PERSONAL') {
                {{ account.user.fullName || '---' }}
              }
              @case ('CORPORATE') {
                {{ account.companyDto?.name || '---' }}
              }
              }
          </span>
          <div class="flex items-center mt-[6px]">
            <mat-icon svgIcon="icon-profile" class="text-[#778F8F] max-w-[7px] max-h-[9px]"></mat-icon>
            @if (account.accountType === 'PERSONAL') {
            <span class="text-[#778F8F] text-[12px] ml-[5px]">
              Personal account
            </span>
            } @else {
            <span class="text-[#778F8F] text-[12px] ml-[5px]">
              {{account.companyRole}}
            </span>
            }
          </div>
        </div>
      </div>
      <div
        class="grow shrink-0 max-w-[24px] max-h-[24px] w-[24px] h-[24px] rounded-[50%] flex flex-col items-center justify-center border border-solid border-[#323142]/30 bg-white">
        <span class="w-[12px] h-[12px] bg-[#323142] rounded-[50%]"></span>
      </div>
    </div>

  }
  <div class="flex flex-col mt-[22px]">
    <div
      class="w-[62px] h-[62px] rounded-[50%] bg-[#ACBBBE]/20 flex flex-col items-center justify-center self-center">
      <mat-icon svgIcon="briefcase" class="!w-full !h-auto max-[36px] max-h-[30px] text-[#ACBBBE]"></mat-icon>
    </div>
  </div>
  <div class="flex flex-col px-[15px]">
    <span class="text-[16px] font-medium self-center mt-[12px]">
      Benefits of a Business Account
    </span>
    <ul
      class="flex flex-col list-marked list-marked-light-gray text-[#778F8F] text-[16px] mt-3 leading-[1.4] gap-y-[10px]">
      <li>
        Team collaboration in a single workspace account.
      </li>
      <li>
        Wallet tracking & monitoring.
      </li>
      <li>
        Full API integration.
      </li>
    </ul>
    <hr class="border-[#022D35]/20 mt-[20px] mb-2">
    <div class="flex items-center justify-center gap-[12px] min-h-[46px] max-h-[46px]">
      <mat-icon svgIcon="laptop-choose-option"
        class="!w-full !h-auto max-w-[35px] max-h-[27px] text-[#022D35]"></mat-icon>
      <span class="text-[#567474] font-bold leading-[1.5] uppercase text-[10px]">
        Choose option
        <br>
        to register business account ↓
      </span>
    </div>
    <div class="grid grid-cols-2 gap-1 pb-2 mt-2">
      <button type="button" (click)="sendRegistrationInstructions()"
        [disabled]="isLoadingRegistration()"
        [ngClass]="{
          'opacity-50 pointer-events-none': isLoadingRegistration()
        }"
        class="focus:bg-[#022D35]/[0.07] hover:bg-[#022D35]/[0.07] focus:text-[#022D35] hover:text-[#022D35] min-h-[142px] bg-[#C93535] rounded-[4px] text-white flex flex-col items-center text-center py-[18px]">
        <div class="h-[36px] w-[36px] flex flex-col items-center justify-center">
          <mat-icon svgIcon="instruction-icon" class="!w-full !h-auto max-w-[32px] max-h-[32px]"></mat-icon>
        </div>
        <span class="leading-[1.25] font-medium text-[16px]">
          Send me <br> Registration <br> instructions
        </span>
      </button>
      <button type="button" [appCopyToClipboardCopied]="linkWebVersion() + '/register-corporate-account'"
        class="focus:bg-[#022D35]/[0.12] hover:bg-[#022D35]/[0.12] min-h-[142px] bg-[#022D35]/[0.07] rounded-[4px] text-[#022D35] flex flex-col items-center text-center py-[18px]">
        <div class="h-[36px] w-[36px] flex flex-col items-center justify-center">
          <mat-icon svgIcon="link-icon" class="!w-full !h-auto max-w-[22px] max-h-[22px]"></mat-icon>
        </div>
        <span class="leading-[1.25] font-medium text-[16px]">
          Copy <br> Registration <br> Link
        </span>
      </button>
    </div>
  </div>
</div>